import React, { useMemo, useState } from 'react';
import './IndividualPerformance.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import ReactApexChart from 'react-apexcharts';
import { useLocation } from 'react-router-dom';

const IndividualPerformance = () => {
  const location = useLocation();
  const userDetails = location.state?.userDetails || null;
  const [selectedDate, setSelectedDate] = useState('');

  const displayName = userDetails?.username || 'Employee Performance';
  const role = userDetails?.role || 'Employee';

  const monthlyValues = [10, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 90];
  const average = Math.round(
    monthlyValues.reduce((sum, value) => sum + value, 0) / monthlyValues.length
  );

  const chartOptions = useMemo(() => ({
    chart: {
      type: 'area',
      toolbar: { show: false },
      zoom: { enabled: false },
      fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
    },
    colors: ['#173452'],
    stroke: {
      curve: 'smooth',
      width: 2.5,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.18,
        opacityTo: 0.02,
        stops: [0, 100],
      },
    },
    dataLabels: { enabled: false },
    markers: {
      size: 3,
      strokeWidth: 2,
      strokeColors: '#ffffff',
      hover: { size: 5 },
    },
    grid: {
      borderColor: 'rgba(23,52,82,0.08)',
      strokeDashArray: 4,
      padding: { left: 6, right: 12 },
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      labels: {
        style: { colors: '#8290a1', fontSize: '10px', fontWeight: 600 },
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: {
        style: { colors: '#8290a1', fontSize: '10px' },
      },
    },
    tooltip: {
      theme: 'light',
      y: {
        formatter: (value) => `${value}`,
      },
    },
  }), []);

  return (
    <div className="individual_performance_page">
      <SideMenuBar />

      <div className="content">
        <NewHeader />

        <main className="individual_container">
          <section className="individual_hero">
            <div className="individual_identity">
              <div className="individual_avatar">
                {displayName.slice(0, 1).toUpperCase()}
              </div>
              <div>
                <span className="individual_kicker">Employee analytics</span>
                <h1 className="name_IndividualPerformance">{displayName}</h1>
                <div className="individual_identity_meta">
                  <span>{role}</span>
                  <i />
                  <span>Performance profile</span>
                </div>
              </div>
            </div>

            <div className="individual_date_control">
              <label htmlFor="date">Review date</label>
              <input
                type="date"
                id="date"
                name="date"
                value={selectedDate}
                onChange={(event) => setSelectedDate(event.target.value)}
                className="date_whiteBox_IndividualPerformance"
              />
            </div>
          </section>

          <section className="individual_overview">
            <div className="individual_metrics">
              <article className="individual_metric_card">
                <span>Present days</span>
                <strong>{userDetails?.total_present_days_count || 0}</strong>
                <small>Attendance record</small>
              </article>

              <article className="individual_metric_card">
                <span>Absent days</span>
                <strong>{userDetails?.total_absent_days_count || 0}</strong>
                <small>Attendance exceptions</small>
              </article>

              <article className="individual_metric_card">
                <span>Tasks completed</span>
                <strong>$123</strong>
                <small>Completion activity</small>
              </article>

              <article className="individual_metric_card">
                <span>Tasks incomplete</span>
                <strong>$123</strong>
                <small>Needs follow-up</small>
              </article>

              <article className="individual_metric_card">
                <span>Over-time hours</span>
                <strong>$123</strong>
                <small>Additional hours</small>
              </article>

              <article className="individual_metric_card">
                <span>Sites completed</span>
                <strong>$123</strong>
                <small>Field activity</small>
              </article>
            </div>

            <aside className="individual_profile_panel">
              <div className="profile_panel_header">
                <div>
                  <span className="section_eyebrow">Profile</span>
                  <h2>Personal information</h2>
                </div>
                <span className="profile_status">Active</span>
              </div>

              <div className="profile_details">
                <div><span>Name</span><strong>{userDetails?.username || 'Not available'}</strong></div>
                <div><span>Role</span><strong>{userDetails?.role || 'Not available'}</strong></div>
                <div><span>Phone</span><strong>{userDetails?.mobile || 'Not available'}</strong></div>
                <div><span>Email</span><strong>{userDetails?.email || 'Not available'}</strong></div>
                <div><span>Address</span><strong>{userDetails?.address || 'Not available'}</strong></div>
              </div>

              <a href="/" className="aOf_whiteBox4_IndividualPerformance">
                View location history <span>→</span>
              </a>
            </aside>
          </section>

          <section className="individual_chart_panel">
            <header className="individual_chart_header">
              <div>
                <span className="section_eyebrow">Performance trend</span>
                <h2>Monthly performance</h2>
                <p>Yearly performance signal across the available monthly series.</p>
              </div>

              <div className="chart_average">
                <span>Average</span>
                <strong>{average}</strong>
              </div>
            </header>

            <div className="individual_chart">
              <ReactApexChart
                options={chartOptions}
                series={[{ name: 'Performance', data: monthlyValues }]}
                type="area"
                height={350}
              />
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default IndividualPerformance;
